import { useState } from "react";
import Sidebar from "../../components/feature/Sidebar";
import TopBar from "../../components/feature/TopBar";
import SnsPanel from "./components/SnsPanel";
import ChartPanel from "./components/ChartPanel";
import PressPanel from "./components/PressPanel";
import PracticePanel from "./components/PracticePanel";

export default function Marketing() {
  const [activeTab, setActiveTab] = useState<"sns" | "chart" | "press" | "practice">("sns");

  const tabs = [
    { key: "sns" as const, label: "SNS 관리", icon: "ri-twitter-x-line" },
    { key: "chart" as const, label: "음원 차트", icon: "ri-bar-chart-line" },
    { key: "press" as const, label: "보도자료", icon: "ri-newspaper-line" },
    { key: "practice" as const, label: "마케팅 실습", icon: "ri-edit-box-line" },
  ];

  return (
    <div className="min-h-screen bg-[#0C0C0E] flex font-sans">
      <Sidebar />
      <div className="flex-1 ml-56 flex flex-col">
        <TopBar />
        <main className="flex-1 p-5 flex flex-col gap-4 overflow-hidden" style={{ height: "calc(100vh - 48px)" }}>
          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#4B6CF7]/10 border border-[#4B6CF7]/20">
                <i className="ri-megaphone-line text-[#7A9BFF] text-base"></i>
              </div>
              <div>
                <h2 className="text-[#F2F2F2] font-semibold text-sm">마케팅 워룸</h2>
                <p className="text-[#555555] text-xs">SNS · 차트 · 보도자료 관리</p>
              </div>
            </div>
            <div className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.06] px-3 py-1.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-[#4B6CF7]/60 animate-pulse inline-block"></span>
              <span className="text-[#555555] text-xs">실시간 모니터링</span>
            </div>
          </div>

          {/* Tab Bar */}
          <div className="flex bg-white/[0.03] border border-white/[0.05] rounded-xl p-1 gap-1 w-fit">
            {tabs.map(tab => (
              <button key={tab.key} type="button" onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-medium cursor-pointer whitespace-nowrap transition-all ${
                  activeTab === tab.key ? "bg-[#4B6CF7]/15 text-[#7A9BFF] border border-[#4B6CF7]/20" : "text-[#444444] hover:text-[#888888]"
                }`}>
                <i className={tab.icon}></i>{tab.label}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="flex-1 overflow-hidden grid lg:grid-cols-3 gap-4">
            <div className={`bg-[#111112] border border-white/[0.05] rounded-xl p-4 flex flex-col overflow-hidden ${activeTab !== "sns" ? "hidden lg:flex" : ""}`}>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-[#CCCCCC] font-medium text-sm">SNS 관리 대시보드</h3>
                <span className="text-[9px] bg-[#4B6CF7]/10 text-[#7A9BFF] border border-[#4B6CF7]/20 px-2 py-0.5 rounded-full">2개 계정</span>
              </div>
              <div className="flex-1 overflow-hidden"><SnsPanel /></div>
            </div>
            <div className={`bg-[#111112] border border-white/[0.05] rounded-xl p-4 flex flex-col overflow-hidden ${activeTab !== "chart" ? "hidden lg:flex" : ""}`}>
              <ChartPanel />
            </div>
            <div className={`bg-[#111112] border border-white/[0.05] rounded-xl p-4 flex flex-col overflow-hidden ${activeTab !== "press" && activeTab !== "practice" ? "hidden lg:flex" : activeTab === "practice" ? "hidden lg:flex" : ""}`}>
              <h3 className="text-[#CCCCCC] font-medium text-sm mb-1">보도자료 배포</h3>
              <p className="text-[#555555] text-xs mb-3">AI 가상 언론사에 홍보 자료를 배포합니다</p>
              <div className="flex-1 overflow-hidden"><PressPanel /></div>
            </div>
            {/* 마케팅 실습 패널 */}
            {activeTab === "practice" && (
              <div className="lg:col-span-3 bg-[#111112] border border-white/[0.05] rounded-xl p-5 flex flex-col overflow-hidden">
                <div className="flex items-center gap-2 mb-4 shrink-0">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#4B6CF7]/10 border border-[#4B6CF7]/20">
                    <i className="ri-edit-box-line text-[#7A9BFF] text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-[#CCCCCC] font-semibold text-sm">마케팅 실습 양식</h3>
                    <p className="text-[#444444] text-[10px]">실무 문서를 직접 작성하며 마케팅 역량을 키워보세요</p>
                  </div>
                </div>
                <div className="flex-1 overflow-y-auto max-w-lg">
                  <PracticePanel onSwitchToSns={() => setActiveTab("sns")} />
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
